import {
  Menu,
  MenuButton,
  MenuList,
  useColorMode,
  IconButton,
  Box,
  MenuOptionGroup,
  MenuItemOption,
} from "@chakra-ui/react";
import { useAppContext } from "./AppContext";
import { EarthSVG } from "./svg/EarthSVG";

export const Language = (): JSX.Element => {
  const { isEnglish, setLanguage } = useAppContext();
  const { colorMode } = useColorMode();

  return (
    <Box position="relative" zIndex={100}>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<EarthSVG color={colorMode === "dark" ? "white" : "black"} />}
        />
        <MenuList p={0} minW="0" w={"100px"}>
          <MenuOptionGroup defaultValue={isEnglish ? "EN" : "ZH"} type="radio">
            <MenuItemOption value="EN" onClick={() => setLanguage("EN")}>
              EN
            </MenuItemOption>
            <MenuItemOption value="ZH" onClick={() => setLanguage("ZHT")}>
              中文
            </MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};
